import { ImageSelection } from './referenceSelectionTypes'

const readFileAsDataUri = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })

export const buildImageSelection = async (
  file: File
): Promise<ImageSelection> => {
  const previewUrl = URL.createObjectURL(file)

  try {
    const dataUri = await readFileAsDataUri(file)
    return { file, previewUrl, dataUri, isProcessing: false, error: null }
  } catch {
    return {
      file,
      previewUrl,
      dataUri: null,
      isProcessing: false,
      error: 'Could not read this image. Please try a different file.',
    }
  }
}
